<template lang="pug">
    //v-card.pa-5
        v-layout( row wrap )
            v-flex( xs12 )
                v-toolbar( color="primary" dark flat )
                    v-toolbar-title Ingrese período para descargar balance de 8 columnas
                    v-spacer
    r-form(
        title='Generar balance de 8 columnas'
        reset-text='reiniciar'
        submit-text='generar'
        ref="refCFEightColumnsBalance"
        v-bind='formProps'
        @submit='submitDownloadEightColumnsBalanceExcel'
    )
                //v-btn.ma-4( color="success" large @click="submitDownloadEightColumnsBalanceExcel") Descargar Excel
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { RForm } from '@/components/reusable_components/next'
    import AccEightColumnsBalanceFields from '@/views/Accounting/AccEightColumnsBalance/AccEightColumnsBalanceFields'
    import { generateEightColumnsBalanceExcel } from '@/services/api/eightColumnsBalance'
    //
    export default {
        name: 'eight-columns-balance-download',
        components: {
            RForm,
        },
        computed: {

            /**
             * 
             */
            ...mapState('SnackbarModalModule', {
                responseConfirm: 'responseConfirm',
            }),

            /**
             * 
             */
            formProps() {
                return {
                    fields: AccEightColumnsBalanceFields,
                }
            },
        },
        methods: {
            // -- UI Modification
            submitDownloadEightColumnsBalanceExcel: function() {
                let vmodels = this.$refs.refCFEightColumnsBalance.value
                if (vmodels.init_date !== '' && vmodels.end_date !== '') {
                    if (vmodels.init_date > vmodels.end_date) {
                        this.showSnackbar(
                            'error',
                            'Error',
                            'La fecha de inicio no puede ser mayor a la fecha de termino'
                        )
                    } else {
                        this.resetSnackbarState()
                        this.setMessageConfirmSnack('Descargar')
                        let payload = this.fillSnack(
                            'info',
                            '¿Desea descargar balance de 8 columnas?',
                            ''
                        )
                        this.initSnackbar(payload)
                    }
                } else {
                    this.showSnackbar(
                        'warning',
                        'Acción inválida',
                        'Complete los campos'
                    )
                }
            },
            // -- Data fetching
            // -- Data handling and transformations
            resetForm: function() {
                this.$refs.refCFEightColumnsBalance.vmodels = []
            },
            // -- Validations and Error handling
            // -- Other functions
            // -- Vuex mappings
            ...mapActions('MenuesModule', {
                setTitleTopBar: 'setTitleTopBar',
            }),
            ...mapActions('SnackbarModalModule', {
                initSnackbar: 'initSnackbar',
                hideSnack: 'hideSnack',
                resetSnackbarState: 'resetSnackbarState',
                setMessageConfirmSnack: 'setMessageConfirmSnack',
            }),
            showSnackbar: function(type, title, message) {
                this.initSnackbar(this.fillSnack(type, title, message))
            },
        },
        watch: {
            // this.$refs.refTaxableForm.vmodels
            async responseConfirm(val) {
                //-
                if (val === 'Descargar') {
                    this.resetSnackbarState()
                    let initDate = this.$refs.refCFEightColumnsBalance.value
                        .init_date
                    let endDate = this.$refs.refCFEightColumnsBalance.value
                        .end_date
                    let branch_office = this.$refs.refCFEightColumnsBalance.value.g_branch_office_id
                    let response = await generateEightColumnsBalanceExcel(
                        initDate,
                        endDate,
                        branch_office,
                    )
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    )
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute(
                        'download',
                        `Balance-8-Columnas-${initDate}_${endDate}.xlsx`
                    )
                    document.body.appendChild(link)
                    link.click()
                    //-
                    if (response.status == 200) {
                        let payload = this.fillSnack(
                            'success',
                            'Descarga correcta',
                            ''
                        )
                        this.initSnackbar(payload)
                        this.resetForm()
                    } else {
                        let payload = this.fillSnack(
                            'error',
                            'Error',
                            response.error
                        )
                        this.initSnackbar(payload)
                    }
                }
            },
        },
        // mixins: [],
        // filters: {},
        // -- Lifecycle Methods
        mounted: function() {
            this.setTitleTopBar('Balance de 8 columnas')
        },
        beforeRouteEnter(to, from, next) {
            next(ctx => {
                if (!ctx.$can('EXECUTE_EXPORT_EIGHT_COLUMNS_BALANCE_EXCEL'))
                    ctx.$router.push('/')
            })
        },
        // -- End Lifecycle Methods
    }
</script>